import React, { useState } from "react";
import { useSetting } from "../../../../context/SettingContext";

// import JS files
// import { showNumSix } from "../../../../constants/constants";

// import Others files
import RingSizeItem from "./RingSizeItem";

const RingsSizeEdit = (props) => {
  let windowWidth = window.screen.width;
  const {showNumSix} = useSetting()
  return (
    <>
      <div className="">
        <div className="flex justify-between mt-2">
          <div className=" basis-1/2 text-center">
            <span className="text-sm md:text-base text-gray-700">سایز</span>
          </div>
          <div className=" basis-1/2 text-center">
            <span className="text-sm md:text-base text-gray-700">
              وزن (برحسب گرم)
            </span>
          </div>
        </div>
        <RingSizeItem
          register={props.register}
          control={props.control}
          label="1"
        />
        <RingSizeItem
          register={props.register}
          control={props.control}
          label="2"
        />
        <RingSizeItem
          register={props.register}
          control={props.control}
          label="3"
        />
        <RingSizeItem
          register={props.register}
          control={props.control}
          label="4"
        />
        <RingSizeItem
          register={props.register}
          control={props.control}
          label="5"
        />
        {showNumSix ? (
          <RingSizeItem
            register={props.register}
            control={props.control}
            label="6"
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default RingsSizeEdit;
